import React, { PropTypes } from "react";

import styled from "styled-components";

import { NitroText, NitroHeading } from "nitro-components";

const Container = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	width: 100%;
`;

const TileMainContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin: 5px;
	width: 50%;
`;

const TileBlock = styled.div`
    display: flex;
    padding: 10px 30px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
`;

const TileHolder = styled.div`
	display: flex;
	flex-direction: row;
	width: 50%;
`;

const Tiles = styled.div`
	display: flex;
	flex-direction: row;
	box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
	width: 100%;
	cursor: pointer;
	
`;

const Border = styled.div`
	margin: 15px 0;
	border-left: 1px solid ${props => props.theme.color.border};
`;

const TileGroupGenerator = ({ potentialSuspension, title, data, action }) => {
	return (
		<TileMainContainer>
			<NitroHeading
				label={title}
				align="center"
				variant="base1"
				size="4"
			/>

			<Tiles onClick={action}>
				{data.map((item, i) => (
					<TileHolder key={i}>
						<TileBlock>
							<NitroHeading
								label={item.Title}
								align="center"
								variant={
                    item.Name === "Potentialdemerits" &&
										potentialSuspension
										? "negative"
										: "base2"
								}
								size="4"
							/>
							<NitroText
								size="30"
								variant={
                    item.Name === "Potentialdemerits" &&
										potentialSuspension
										? "negative"
										: "base1"
								}
							>
								{item.Value}
							</NitroText>
						</TileBlock>
						{i < data.length - 1 ? <Border /> : null}

					</TileHolder>
				))}

			</Tiles>
		</TileMainContainer>
	);
};

const DriverSafetyDetails = ({
	potentialSuspension,
	licenseReviewData,
	accidentData,
	error,
	openDetails
}) => {
	return (
		<div>
			<Container>
				{licenseReviewData &&
					<TileGroupGenerator
						potentialSuspension={potentialSuspension}
						title={`License review`}
						data={licenseReviewData}
						action={()=>{
							openDetails({'categoryFilter':'LicenseReview'});
						}}
					/>}
				{accidentData &&
					<TileGroupGenerator
						title={`Accidents`}
						data={accidentData}
						action={()=>{
							openDetails({'categoryFilter':'Accidents'});
						}}
					/>}

			</Container>
		</div>
	);
};

DriverSafetyDetails.propTypes = {
	potentialSuspension: PropTypes.bool,
	licenseReviewData: PropTypes.array.isRequired,
	accidentData: PropTypes.array.isRequired,
	data: PropTypes.object,
	error: PropTypes.bool, // TODO .isRequired
	openDetails: PropTypes.func
};

export default DriverSafetyDetails;



// WEBPACK FOOTER //
// ./src/features/insights/components/driverSafety/components/DriverSafetyDetails.js